import { errorNetworkIn } from "../../logging/logging";
export var decodeIdInWrapper = function (value, TypeResponse, decodeCommand) {
    var protoPayload = new Uint8Array(value);
    var commandId = -1;
    try {
        // As any cast required to be able to cast decoded value to TResponseWrapper
        var decodedWrapper = TypeResponse.decode(protoPayload);
        commandId = decodedWrapper.commandId;
        return decodeCommand(commandId, decodedWrapper);
    }
    catch (err) {
        // TODO: handle errors while decoding message
        errorNetworkIn("Error when decoding the message:", err);
    }
    return {
        id: commandId,
        props: undefined,
        sequenceNumber: -1,
        statusCode: -1,
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/network/decoder/decodeIdInWrapper.ts
// module id = 2986
// module chunks = 3